<template>
  <div id="app">
    <div class="web_container">
      <div class="body_container">
        <img class="logo" src="../assets/logo.png" />
        <ul class="content_container">
          <li :class="currentIndex == index?'selected':''" @click="onItemClick(index)" v-for="(item,index) in items">
            {{item.title}}
          </li>
        </ul>
      </div>
    </div>

    <div class="phone_container">
      <div class="phone_body_container">
        <img class="phone_logo" src="../assets/phone_logo.png" />
        <img class="phone_menu" src="../assets/navigation/phone_ico_menu.png" @click.stop="openMenu()" />
      </div>

      <ul class="phone_content_container" v-if="!isHidden" @click="closeMenu()">
        <div class="phone_menu_container">
          <li @click.stop="onItemClick(index)" v-for="(item,index) in items">
            {{item.title}}
          </li>
        </div>
      </ul>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        currentIndex: 0,
        isHidden: true,
        items: [{
            title: '慧日永明',
            index: 0
          },
          {
            title: '猫砍大画',
            index: 1
          },
          {
            title: '文创产品',
            index: 2
          },
          {
            title: '软件应用',
            index: 3
          },
          {
            title: '清兮静坐',
            index: 4
          },
          {
            title: '业务合作',
            index: 5
          },
          {
            title: '人才招聘',
            index: 6
          },
        ],
      };
    },
    watch: {
      $route: {
        handler(val, oldval) {
          switch (val["path"]) {
            case '/':
              this.currentIndex = 0;
              break;
            case '/BigPicture':
              this.currentIndex = 1;
              break;
            case '/CulturalProducts':
              this.currentIndex = 2;
              break;
            case '/Application':
              this.currentIndex = 3;
              break;
            case '/ApplicationIntro':
              this.currentIndex = 4;
              break;
            case '/BusinessCooperation':
              this.currentIndex = 5;
              break;
            case '/TalentRecruitment':
              this.currentIndex = 6;
              break;
          }
        },
        // 深度观察监听
        deep: true
      }
    },
    mounted: function() {

    },
    methods: {
      openMenu() {
        if (this.isHidden) {
          this.isHidden = false;
        } else {
          this.isHidden = true;
        };
      },
      closeMenu() {
        if (this.isHidden == 0) {
          this.isHidden = true;
        }
      },
      onItemClick(index) {
        this.currentIndex = index;
        this.isHidden = true;
        switch (this.currentIndex) {
          case 0:
            this.$router.replace({
              name: 'Home'
            })
            break;
          case 1:
            this.$router.replace({
              path: '/BigPicture'
            })
            break;
          case 2:
            this.$router.replace({
              path: '/CulturalProducts'
            })
            break;
          case 3:
            this.$router.replace({
              path: '/Application'
            })
            break;
          case 4:
            this.$router.replace({
              path: '/ApplicationIntro'
            })
            break;
          case 5:
            this.$router.replace({
              path: '/BusinessCooperation'
            })
            break;
          case 6:
            this.$router.replace({
              path: '/TalentRecruitment'
            })
            break;
        }
      }
    }
  }
</script>

<style scoped>
  @font-face {
    font-family: ht;
    src: url("../assets/font/HT.otf");
  }

  .web_container {
    width: 100%;
  }

  .body_container {
    width: 100%;
    height: 4.166666vw;
    background: #ffffff;
    display: flex;
    align-items: center;
  }

  .logo {
    height: 2.5vw;
    width: 2.5vw;
    margin-left: 18.854166vw;
  }

  .content_container {
    display: flex;
  }

  .content_container li {
    margin-left: 3.75vw;
    font-size: 1.041666vw;
    font-family: 'PingFang SC';
    color: #000000;
  }

  .selected {
    font-size: 1.041666vw;
    font-family: 'PingFang SC';
    color: #000000;
    border-radius: 0.104166vw;
    border-bottom: 0.208333vw solid #333333
  }

  .web_container {
    width: 100%;
  }

  .phone_body_container {
    width: 100%;
    height: 12.8vw;
    background-color: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .phone_logo {
    height: 8.533333vw;
    width: 8.533333vw;
    margin-left: 5.333333vw;
  }

  .phone_menu {
    height: 8.533333vw;
    width: 8.533333vw;
    margin-right: 5.333333vw;
  }

  .phone_content_container {
    display: flex;
    flex-direction: column;
    background: rgb(255, 255, 255, 0.1);
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 100;
  }

  .phone_menu_container {
    background: #ffffff;
    height: 100%;
    width: 74.666666vw;
  }

  .phone_content_container li {
    width: 50vw;
    font-size: 4.266666vw;
    font-family: ht;
    text-align: center;
    margin-top: 12.533333vw;
    color: rgba(0, 0, 0, 1);
  }
</style>



// WEBPACK FOOTER //
// src/components/navigation.vue